// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"d7e8af79","453":"b5d3b766","934":"53253ae7"}[chunkId] + ".chunk.js";
};